<div class="card step-card flex flex-column">
  <form [formGroup]="userForm" *ngIf="userForm">
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label>{{'model.tenant' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <p-dropdown
            [placeholder]="'select.tenant' | transloco"
            [options]="tenants"
            [filter]="true"
            (onChange)="tenantChanged($event)"
            styleClass="w-full"
            id="tenantUUID"
            optionLabel="name"
            optionValue="uuid"
            formControlName="tenantUUID"
          ></p-dropdown>
        </div>
      </div>
      <div class="col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label>{{'model.organization' | transloco}}</label><br>
        </div>
        <div class="col-12">
          <p-dropdown
            [placeholder]="'select.organization' | transloco"
            [options]="organizations"
            [filter]="true"
            styleClass="w-full"
            id="organizationUUID"
            optionLabel="name"
            optionValue="uuid"
            formControlName="organizationUUID"
          ></p-dropdown>
        </div>
      </div>
    </div>
    <hr style="border-color: #eceeec; width: 65%;" class="mx-auto">
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label>{{'attribute.firstName' | transloco}}</label>
        </div>
        <div class="col-12">
          <input pInputText id="firstName" type="text" formControlName="firstName" class="w-full">
        </div>
        <app-validation-errors [control]="userForm.get('firstName')"></app-validation-errors>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label>{{'attribute.lastName' | transloco}}</label>
        </div>
        <div class="col-12">
          <input pInputText id="lastName" type="text" formControlName="lastName" class="w-full">
        </div>
        <app-validation-errors [control]="userForm.get('lastName')"></app-validation-errors>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label>{{'attribute.userenabled' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-checkbox id="enabled" formControlName="enabled" binary="true" class="w-full"></p-checkbox>
        </div>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label>{{'attribute.username' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <input pInputText id="username" type="text" formControlName="username" class="w-full">
        </div>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label>{{'attribute.email' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <input pInputText id="email" type="text" formControlName="email" class="w-full">
        </div>
        <app-validation-errors [control]="userForm.get('email')"></app-validation-errors>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label>{{'attribute.emailVerified' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-checkbox id="emailVerified" formControlName="emailVerified" binary="true" class="w-full"></p-checkbox>
        </div>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label>{{'attribute.requireduseractions' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-multiSelect
            [options]="requiredUserActions"
            formControlName="requieredActions"
            optionLabel="name"
            optionValue="code"
            display="chip"
            styleClass="w-full"
          ></p-multiSelect>
        </div>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label>{{'attribute.language' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-dropdown
            [options]="languageOptions"
            [(ngModel)]="selectedLanguage"
            [ngModelOptions]="{standalone: true}"
            optionLabel="name"
            filterBy="name"
            styleClass="w-full dropdown-language"
          >
            <ng-template pTemplate="selectedItem">
              <div class="flex align-items-center">
                <i [class]="'flag-icon flag-icon-' + selectedLanguage.code"></i>
                <p class="mb-0 ml-1 p-0">{{selectedLanguage.name}}</p>
              </div>
            </ng-template>
            <ng-template let-language pTemplate="item">
              <div class="flex align-items-center">
                <i [class]="'flag-icon flag-icon-' + language.code"></i>
                <p class="mb-0 ml-1 p-0">{{language.name}}</p>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label>{{'attribute.timezone' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-dropdown
            [placeholder]="'select.generic' | transloco"
            [options]="timeZoneOptions"
            [filter]="true"
            styleClass="w-full"
            id="timeZone"
            optionValue="name"
            optionLabel="name"
            formControlName="timeZone"
          ></p-dropdown>
        </div>
      </div>
    </div>
  </form>

  <div class="mt-auto">
    <div class="flex flex-column sm:flex-row justify-content-between">
      <div class="flex justify-content-between sm:justify-content-start sm:flex-order-1">
        <button
          [label]="'common.next' | transloco"
          [disabled]="!userForm?.valid"
          (click)="onNextStep()"
          pButton
          pRipple
          class="flex-1"
          icon="pi pi-angle-right"
          iconPos="right"
        ></button>
      </div>
      <button
        [label]="'common.cancel' | transloco"
        [routerLink]="'/management/users'"
        pButton
        pRipple
        class="p-button-danger mt-2 sm:mt-0 sm:flex-order-0"
      ></button>
    </div>
  </div>

</div>
